// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Belt_Int = require("rescript/lib/js/belt_Int.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Expln_React_Row = require("../../rescript-utils/main/react-mui-components/Expln_React_Row.res.js");
var MM_react_common = require("../ui-utils/MM_react_common.res.js");
var Expln_React_Column = require("../../rescript-utils/main/react-mui-components/Expln_React_Column.res.js");
var Expln_React_common = require("../../rescript-utils/main/Expln_React_common.res.js");
var Paper = require("@mui/material/Paper").default;
var Button = require("@mui/material/Button").default;
var Checkbox = require("@mui/material/Checkbox").default;
var TextField = require("@mui/material/TextField").default;
var Save = require("@mui/icons-material/Save").default;
var IconButton = require("@mui/material/IconButton").default;
var FormControlLabel = require("@mui/material/FormControlLabel").default;

var nonDigitPattern = /\D/g;

function MM_cmp_editor_view_options(props) {
  var onClose = props.onClose;
  var onStepsPerPageChange = props.onStepsPerPageChange;
  var stepsPerPage = props.stepsPerPage;
  var onSmallBtnsChange = props.onSmallBtnsChange;
  var smallBtns = props.smallBtns;
  var onInlineModeChange = props.onInlineModeChange;
  var inlineMode = props.inlineMode;
  var onShowJstfChange = props.onShowJstfChange;
  var showJstf = props.showJstf;
  var onShowTypeChange = props.onShowTypeChange;
  var showType = props.showType;
  var onShowLabelChange = props.onShowLabelChange;
  var showLabel = props.showLabel;
  var onShowCheckboxChange = props.onShowCheckboxChange;
  var showCheckbox = props.showCheckbox;
  var match = React.useState(function () {
        return showCheckbox;
      });
  var setShowCheckbox = match[1];
  var showCheckbox$1 = match[0];
  var match$1 = React.useState(function () {
        return showLabel;
      });
  var setShowLabel = match$1[1];
  var showLabel$1 = match$1[0];
  var match$2 = React.useState(function () {
        return showType;
      });
  var setShowType = match$2[1];
  var showType$1 = match$2[0];
  var match$3 = React.useState(function () {
        return showJstf;
      });
  var setShowJstf = match$3[1];
  var showJstf$1 = match$3[0];
  var match$4 = React.useState(function () {
        return inlineMode;
      });
  var setInlineMode = match$4[1];
  var inlineMode$1 = match$4[0];
  var match$5 = React.useState(function () {
        return smallBtns;
      });
  var setSmallBtns = match$5[1];
  var smallBtns$1 = match$5[0];
  var match$6 = React.useState(function () {
        return stepsPerPage;
      });
  var setCurStepsPerPage = match$6[1];
  var match$7 = React.useState(function () {
        
      });
  var setStepsPerPageText = match$7[1];
  var stepsPerPageText = match$7[0];
  var stepsPerPageTextEffective = Belt_Option.getWithDefault(stepsPerPageText, String(match$6[0]));
  var actChangeStepsPerPage = function () {
    var newStepsPerPage = Belt_Int.fromString(stepsPerPageTextEffective);
    if (newStepsPerPage !== undefined) {
      onStepsPerPageChange(newStepsPerPage);
      setCurStepsPerPage(function (param) {
            return newStepsPerPage;
          });
      return setStepsPerPageText(function (param) {
                  
                });
    }
    
  };
  React.useEffect((function () {
          onShowCheckboxChange(showCheckbox$1);
        }), [showCheckbox$1]);
  React.useEffect((function () {
          onShowLabelChange(showLabel$1);
        }), [showLabel$1]);
  React.useEffect((function () {
          onShowTypeChange(showType$1);
        }), [showType$1]);
  React.useEffect((function () {
          onShowJstfChange(showJstf$1);
        }), [showJstf$1]);
  React.useEffect((function () {
          onInlineModeChange(inlineMode$1);
        }), [inlineMode$1]);
  React.useEffect((function () {
          onSmallBtnsChange(smallBtns$1);
        }), [smallBtns$1]);
  return React.createElement(Paper, {
              style: {
                padding: "10px"
              },
              children: Caml_option.some(React.createElement(Expln_React_Column.make, {
                        children: Caml_option.some(null)
                      }, React.createElement("span", {
                            style: {
                              fontSize: "1.1em",
                              fontWeight: "bold"
                            }
                          }, "View Options"), React.createElement(Button, {
                            onClick: (function (param) {
                                onClose();
                              }),
                            children: "Close"
                          }), React.createElement(FormControlLabel, {
                            control: React.createElement(Checkbox, {
                                  checked: showCheckbox$1,
                                  onChange: Expln_React_common.evt2bool(function (b) {
                                        setShowCheckbox(function (param) {
                                              return b;
                                            });
                                      })
                                }),
                            label: "Checkbox"
                          }), React.createElement(FormControlLabel, {
                            control: React.createElement(Checkbox, {
                                  checked: showLabel$1,
                                  onChange: Expln_React_common.evt2bool(function (b) {
                                        setShowLabel(function (param) {
                                              return b;
                                            });
                                      })
                                }),
                            label: "Label"
                          }), React.createElement(FormControlLabel, {
                            control: React.createElement(Checkbox, {
                                  checked: showType$1,
                                  onChange: Expln_React_common.evt2bool(function (b) {
                                        setShowType(function (param) {
                                              return b;
                                            });
                                      })
                                }),
                            label: "Step type"
                          }), React.createElement(FormControlLabel, {
                            control: React.createElement(Checkbox, {
                                  checked: showJstf$1,
                                  onChange: Expln_React_common.evt2bool(function (b) {
                                        setShowJstf(function (param) {
                                              return b;
                                            });
                                      })
                                }),
                            label: "Justification"
                          }), React.createElement(FormControlLabel, {
                            control: React.createElement(Checkbox, {
                                  checked: inlineMode$1,
                                  onChange: Expln_React_common.evt2bool(function (b) {
                                        setInlineMode(function (param) {
                                              return b;
                                            });
                                      })
                                }),
                            label: "Compact mode"
                          }), React.createElement(FormControlLabel, {
                            control: React.createElement(Checkbox, {
                                  checked: smallBtns$1,
                                  onChange: Expln_React_common.evt2bool(function (b) {
                                        setSmallBtns(function (param) {
                                              return b;
                                            });
                                      })
                                }),
                            label: "Small buttons"
                          }), React.createElement(Expln_React_Row.make, {
                            children: Caml_option.some(null)
                          }, React.createElement(TextField, {
                                value: stepsPerPageTextEffective,
                                label: "Steps per page",
                                size: "small",
                                style: {
                                  width: "110px"
                                },
                                onChange: Expln_React_common.evt2str(function (newStepsPerPage) {
                                      setStepsPerPageText(function (param) {
                                            return newStepsPerPage.replace(nonDigitPattern, "");
                                          });
                                    }),
                                onKeyDown: MM_react_common.kbrdHnd2(MM_react_common.kbrdClbkMake(MM_react_common.keyEnter, undefined, undefined, undefined, actChangeStepsPerPage), MM_react_common.kbrdClbkMake(MM_react_common.keyEsc, undefined, undefined, undefined, onClose)),
                                autoFocus: true
                              }), React.createElement(IconButton, {
                                onClick: (function (param) {
                                    actChangeStepsPerPage();
                                  }),
                                color: "primary",
                                disabled: Belt_Option.isNone(stepsPerPageText),
                                children: Caml_option.some(React.createElement(Save, {}))
                              })), React.createElement(Button, {
                            onClick: (function (param) {
                                onClose();
                              }),
                            children: "Close"
                          })))
            });
}

var make = MM_cmp_editor_view_options;

exports.nonDigitPattern = nonDigitPattern;
exports.make = make;
/* react Not a pure module */
